import { memo } from "react";
import { titleCase } from "../../../../utils";
import { canEditIdentificationDocumentPayload } from "../../utils/identificationDocumentEdit";
import { DocumentTypeRenderer } from "../BinaryContent/DocumentTypeRenderer";
import { StepComponentProps, StepRegistryEntry } from "./types";

const IdentificationStep = memo((props: StepComponentProps) => {
  const {
    stepConfig,
    documents,
    requestId,
    companyRole,
    canEdit,
    comments,
    addComment,
    userInfo,
    isMobile,
    statusesConfig,
    onRefreshDocuments,
    expandedDocumentType,
    identificationProvider,
  } = props;

  if (documents.length === 0) {
    return null;
  }

  return (
    <>
      {documents.map((doc) => (
        <DocumentTypeRenderer
          key={doc.document.documentId || doc.document.documentType}
          document={doc}
          requestId={requestId}
          title={titleCase(doc.document.documentType)}
          companyRole={companyRole}
          canEdit={canEdit}
          allowIdentificationEdit={canEditIdentificationDocumentPayload(
            stepConfig,
            doc,
            canEdit,
            identificationProvider,
          )}
          comments={comments}
          addComment={addComment}
          userInfo={userInfo}
          isMobile={isMobile}
          statusesConfig={statusesConfig}
          onRefreshDocuments={onRefreshDocuments}
          defaultExpanded={
            expandedDocumentType === doc.document.documentType
          }
        />
      ))}
    </>
  );
});

export const IdentificationEntry: StepRegistryEntry = {
  StepComponent: IdentificationStep,
};
